import React, { Fragment } from 'react';
import AddIcon from '@atlaskit/icon/glyph/add';
import styled from '@emotion/styled';
import { map } from 'lodash';
import { Logo, Subtitle } from './components';
import { WacSignupHeaderProps } from './model';
import { useSignUpFormConfig } from '../../../../hook';

function WacSignupHeader({
  productKeys,
  isWhiteBackground = false
}: WacSignupHeaderProps) {
  const { edition, bundle } = useSignUpFormConfig();
  const headerBuffer: JSX.Element[] = [];
  const isJiraFamily = bundle === 'jira';
  isJiraFamily
    ? headerBuffer.push(Logo(productKeys[0], isWhiteBackground))
    : map(productKeys, (productKey) =>
        headerBuffer.push(Logo(productKey, isWhiteBackground))
      );

  if (headerBuffer.length > 1 && !isJiraFamily) {
    return (
      <Container>
        <HeaderContainerWithPlus>
          {headerBuffer.map((item, index) =>
            index === 0 ? (
              <Fragment key={index}>{item}</Fragment>
            ) : (
              <Fragment key={index}>
                <PlusIcon>
                  <AddIcon label="" key="plusSign" primaryColor="white" />
                </PlusIcon>
                {item}
              </Fragment>
            )
          )}
        </HeaderContainerWithPlus>
        <div>{Subtitle(edition, isWhiteBackground)}</div>
      </Container>
    );
  }
  return (
    <Container>
      <HeaderContainer>
        {headerBuffer.map((item, index) => (
          <Fragment key={index}>{item}</Fragment>
        ))}
      </HeaderContainer>
      <div>{Subtitle(edition, isWhiteBackground)}</div>
    </Container>
  );
}

export default WacSignupHeader;

const Container = styled.div`
  margin: 10px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  font-family: Charlie Text, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto,
    Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
`;

const PlusIcon = styled.div`
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 15px;
  display: inline-block;
  position: relative;
  bottom: 10px;
`;
const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  svg,
  img {
    margin-bottom: 0px !important;
  }
`;
const HeaderContainerWithPlus = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    margin-bottom: 0px !important;
  }
`;
